import { AccountCreationStep } from 'components/invitationScreen/AccountCreationStep';
import { InvitationScreenLayout } from 'layout/inviteLayout';

export const AccountCreationScreen = () => {
	return (
		<InvitationScreenLayout>
			<AccountCreationStep />
		</InvitationScreenLayout>
	);
};
